import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import store from './lib/store.js'
import router from './lib/router.js'
import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'
import ConfirmationService from 'primevue/confirmationservice'
import DialogService from 'primevue/dialogservice'
import { definePreset } from '@primevue/themes'
import ToastService from 'primevue/toastservice'
import 'highlight.js/styles/monokai.css'
import hljs from 'highlight.js/lib/core'
import json from 'highlight.js/lib/languages/json'
import VueHighlightJS from '@highlightjs/vue-plugin'
hljs.registerLanguage('json', json)
import Ripple from 'primevue/ripple'
import 'primeicons/primeicons.css'

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{indigo.50}',
      100: '{indigo.100}',
      200: '{indigo.200}',
      300: '{indigo.300}',
      400: '{indigo.400}',
      500: '{indigo.500}',
      600: '{indigo.600}',
      700: '{indigo.700}',
      800: '{indigo.800}',
      900: '{indigo.900}',
      950: '{indigo.950}'
    }
  }
})

const app = createApp(App)
app
  .use(router)
  .use(store)
  .use(VueHighlightJS)
  .use(PrimeVue, {
    ripple: true,
    theme: {
      preset: MyPreset,
      options: {
        darkModeSelector: '.dark'
      }
    }
  })
  .use(ConfirmationService)
  .use(DialogService)
  .use(ToastService)
  .directive('ripple', Ripple)
  .directive('focus', {
    mounted (el, { modifiers, value }) {
      if (value === false) return
      if (modifiers.timeout) {
        setTimeout(() => el.focus(), 400)
      } else el.focus()
    }
  })
  .mount('#app')
